import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import type { TravelerCaptureSource } from '@bandido/shared/types';
import { client } from '@frontend/features/common/services';
import { captureKey, capturePath } from './queries';

export const useCaptureSourceDetail = (caseId: number, source: TravelerCaptureSource) =>
  useQuery({
    queryKey: [...captureKey(caseId), 'source', source.id],
    queryFn: async ({ signal }) => {
      const path = `${capturePath(caseId)}/sources/${encodeURIComponent(source.id)}`;
      if (source.kind === 'file') {
        const response = await client.get<Blob>(`${path}/file`, { responseType: 'blob', signal });
        return { blob: response.data, text: undefined, truncated: false };
      }
      const response = await client.get<{ text: string; truncated: boolean }>(path, { signal });
      return { ...response.data, blob: undefined };
    },
    cacheTime: 0,
    staleTime: Infinity,
    retry: false,
  });

export function useCaptureObjectUrl(blob?: Blob) {
  const [value, setValue] = useState<{ blob: Blob; url: string }>();
  useEffect(() => {
    if (!blob) return;
    const url = URL.createObjectURL(blob);
    setValue({ blob, url });
    return () => URL.revokeObjectURL(url);
  }, [blob]);
  return value?.blob === blob ? value?.url : undefined;
}
